// utils/orderUtils.ts

import { Order } from "src/shared/services/interfacev2";
import { PaymentData } from "../../types/order";

export const clearPaymentInput = (): PaymentData => ({
  discount: "0",
  ReceivedAmount: "",
  paymentMethod: "cash",
});

export const handlePaymentInputChange = (
  e: React.ChangeEvent<HTMLInputElement>, 
  order: Order | null, 
  setPaymentData: React.Dispatch<React.SetStateAction<PaymentData>>
) => {
  const { name, value } = e.target;
  
  // ✅ Allow empty string
  if (value === "") {
    setPaymentData((prev) => ({ ...prev, [name]: value }));
    return;
  }

  // ✅ Only allow numbers and decimals
  if (!/^\d*\.?\d*$/.test(value)) {
    return;
  }

  // ✅ Always update the state with the raw value
  // Let the parent component handle validation
  setPaymentData((prev) => ({ ...prev, [name]: value }));
};

export const formatDate = (date: Date) => 
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const formatTime = (date: Date) =>
  `${String(date.getHours()).padStart(2, "0")}:` +
  `${String(date.getMinutes()).padStart(2, "0")}:` +
  `${String(date.getSeconds()).padStart(2, "0")}`;